function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import * as React from "react";
import Select from "react-select";
import "./paymentMethods.scss";
import { InputRut, Input, CardDate } from "../../../../../helperComponents";
import { TipoDePagoTypes } from "../../../../../utils/data";

var CreditCardInfo = function CreditCardInfo(props) {
  var poliza = props.poliza,
      token = props.token,
      banksOption = props.banksOption,
      _onChange = props.onChange; // Estado inicial: verificar si los datos del contratante ya están cargados

  var getInitialCheckState = function getInitialCheckState() {
    var user_id = poliza.payment_information.user_id;
    var contratante_id = poliza.contratante.id;
    return user_id === contratante_id && poliza.payment_information.titular_name && poliza.payment_information.titular_rut;
  };

  var _React$useState = React.useState(getInitialCheckState),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      isCheckContratante = _React$useState2[0],
      setIsCheckContratante = _React$useState2[1]; // Guardar los datos originales del payment_information cuando se carga el componente


  var originalPaymentInfoRef = React.useRef(null); // Inicializar con los datos originales cuando se carga el componente

  React.useEffect(function () {
    if (poliza.payment_information && poliza.payment_information.id && !originalPaymentInfoRef.current) {
      originalPaymentInfoRef.current = _objectSpread({}, poliza.payment_information);
    }
  }, []);
  var cardTypeOptions = [{
    value: "visa",
    label: "VISA"
  }, {
    value: "masterCard",
    label: "MasterCard"
  }, {
    value: "americanExpress",
    label: "American Express"
  }];
  var selectedBank = poliza.payment_information.bank_id ? banksOption.find(function (option) {
    return parseInt(option.value) === poliza.payment_information.bank_id;
  }) : null;
  var selectedCardType = poliza.payment_information.account_type ? cardTypeOptions.find(function (option) {
    return option.value === poliza.payment_information.account_type;
  }) : null;

  var onCopyToContratante = function onCopyToContratante() {
    if (!_onChange) return; // Obtener bank_id del contratante

    var bankId = null; // Primero intentar obtener bank_id directamente si está disponible

    if (poliza.contratante.bank_id) {
      bankId = typeof poliza.contratante.bank_id === 'number' ? poliza.contratante.bank_id : parseInt(poliza.contratante.bank_id);
    } // Si no hay bank_id, intentar obtenerlo desde bank_name (objeto Bank)
    else if (poliza.contratante.bank_name && typeof poliza.contratante.bank_name === 'object' && poliza.contratante.bank_name.id) {
      bankId = poliza.contratante.bank_name.id;
    } // Si bank_name es un string, buscar en banksOption
    else if (poliza.contratante.bank_name) {
      var bankName = typeof poliza.contratante.bank_name === 'string' ? poliza.contratante.bank_name : poliza.contratante.bank_name.name || poliza.contratante.bank_name;

      if (bankName) {
        // Búsqueda flexible: exacta primero, luego parcial
        var foundBank = banksOption.find(function (option) {
          var optionLabel = option.label.toLowerCase().trim();
          var searchName = bankName.toLowerCase().trim(); // Búsqueda exacta

          if (optionLabel === searchName) return true; // Búsqueda parcial (el nombre del banco contiene el texto buscado o viceversa)

          if (optionLabel.includes(searchName) || searchName.includes(optionLabel)) return true;
          return false;
        });

        if (foundBank) {
          bankId = parseInt(foundBank.value);
        }
      }
    } // Determinar tipo de tarjeta


    var accountType = null;

    if (poliza.contratante.bank_account_type) {
      var validCardTypes = ['visa', 'masterCard', 'americanExpress'];
      var lowerType = poliza.contratante.bank_account_type.toLowerCase();

      if (validCardTypes.includes(lowerType)) {
        accountType = lowerType;
      }
    } // Si el contratante no tiene datos bancarios, intentar restaurar desde los datos originales
    // siempre que el user_id original coincida con el contratante


    var originalInfo = originalPaymentInfoRef.current;
    var shouldRestoreFromOriginal = originalInfo && originalInfo.user_id === poliza.contratante.id && (!bankId || !accountType || !poliza.contratante.bank_account_number); // Copiar todos los campos del contratante, igual que RUT y nombre titular
    // Si no hay datos en el contratante pero hay datos originales del mismo user_id, restaurarlos

    var updatedPaymentInfo = _objectSpread(_objectSpread({}, poliza.payment_information), {}, {
      titular_rut: poliza.contratante.rut || null,
      titular_name: poliza.contratante.full_name || null,
      user_id: poliza.contratante.id || null,
      bank_id: bankId || (shouldRestoreFromOriginal ? originalInfo.bank_id : null),
      account_type: accountType || (shouldRestoreFromOriginal ? originalInfo.account_type : null),
      account_number: poliza.contratante.bank_account_number || (shouldRestoreFromOriginal ? originalInfo.account_number : null),
      card_expiration: shouldRestoreFromOriginal ? originalInfo.card_expiration : null
    });

    _onChange(updatedPaymentInfo);
  };

  var onChangeCheckContratante = function onChangeCheckContratante() {
    var newIsCheckContratante = !isCheckContratante; // Lógica corregida: cuando se marca, copiar datos; cuando se desmarca, limpiar campos relacionados

    if (newIsCheckContratante) {
      onCopyToContratante();
    } else {
      // Limpiar campos relacionados con el titular y datos bancarios
      _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        titular_rut: null,
        titular_name: null,
        user_id: null,
        bank_id: null,
        account_type: null,
        account_number: null,
        card_expiration: null
      }));
    }

    setIsCheckContratante(newIsCheckContratante);
  };

  React.useEffect(function () {
    var user_id = poliza.payment_information.user_id;
    var contratante_id = poliza.contratante.id; // Si los datos del contratante están cargados automáticamente, marcar como copiado

    if (user_id === contratante_id && poliza.payment_information.titular_name && poliza.payment_information.titular_rut) {
      setIsCheckContratante(true);
    } else if (user_id && user_id !== contratante_id && isCheckContratante) {
      setIsCheckContratante(false);
    }
  }, [poliza.payment_information.user_id, poliza.payment_information.titular_name, poliza.payment_information.titular_rut, poliza.contratante.id]);
  return /*#__PURE__*/React.createElement("div", {
    className: "container-fluid cntCreditCardInfo"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("h5", {
    className: "title"
  }, "M\xE9todo de pago: Tarjeta de Cr\xE9dito")), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-12 checkbox"
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    checked: isCheckContratante,
    onChange: onChangeCheckContratante
  }), "Copiar datos del contratante"))), /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement(InputRut, {
    value: poliza.payment_information.titular_rut,
    token: token,
    title: "Rut Titular",
    onUserIsExist: function onUserIsExist(user) {
      if (_onChange) {
        // Cargar datos bancarios del usuario seleccionado
        var updatedPaymentInfo = _objectSpread(_objectSpread({}, poliza.payment_information), {}, {
          titular_rut: user.rut,
          titular_name: user.full_name,
          user_id: user.id
        }); // Si es tarjeta de crédito, establecer valores por defecto


        if (poliza.tipo_de_pago === TipoDePagoTypes.PAT) {
          var _poliza$contratante;

          updatedPaymentInfo.payment_type = 'credit_card';
          updatedPaymentInfo.account_type = ((_poliza$contratante = poliza.contratante) === null || _poliza$contratante === void 0 ? void 0 : _poliza$contratante.bank_account_type) || 'visa'; // Usar valor real del usuario o fallback
        }

        _onChange(updatedPaymentInfo);
      }
    },
    onInputChange: function onInputChange(inputValue) {
      if (_onChange) {
        // Buscar automáticamente el usuario si el RUT es válido
        if (inputValue && inputValue.length >= 8) {
          // RUT mínimo válido
          // Hacer búsqueda automática del usuario
          fetch("/api/v1/users?inputSearch=".concat(inputValue), {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-Token": token
            }
          }).then(function (response) {
            return response.json();
          }).then(function (users) {
            // Buscar usuario que coincida exactamente con el RUT
            var matchingUser = users.find(function (user) {
              return user.rut && user.rut.replace(/[^0-9kK]/g, '') === inputValue.replace(/[^0-9kK]/g, '');
            });

            if (matchingUser) {
              // Autocompletar datos del usuario encontrado
              _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
                titular_rut: matchingUser.rut,
                titular_name: matchingUser.full_name,
                user_id: matchingUser.id
              }));
            } else {
              // Solo actualizar RUT si no se encuentra usuario
              _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
                titular_rut: inputValue,
                user_id: null
              }));
            }
          })["catch"](function (error) {
            console.error('Error buscando usuario:', error); // En caso de error, solo actualizar RUT

            _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
              titular_rut: inputValue,
              user_id: null
            }));
          });
        } else {
          // Si el RUT es muy corto, solo actualizar RUT
          _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
            titular_rut: inputValue,
            user_id: null
          }));
        }
      }
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Nombre Titular"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.payment_information.titular_name,
    classNameInput: "form-control",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        titular_name: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Banco"), /*#__PURE__*/React.createElement(Select, {
    value: selectedBank,
    options: banksOption,
    placeholder: "Selecciona...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        bank_id: parseInt(item.value)
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Tipo de Tarjeta"), /*#__PURE__*/React.createElement(Select, {
    value: selectedCardType,
    options: cardTypeOptions,
    placeholder: "Selecciona...",
    onChange: function onChange(item) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        account_type: item.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "N\xFAmero de Tarjeta"), /*#__PURE__*/React.createElement(Input, {
    value: poliza.payment_information.account_number,
    classNameInput: "form-control",
    onChange: function onChange(event) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        account_number: event.target.value
      }));
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: "col-md-2"
  }, /*#__PURE__*/React.createElement("label", {
    className: "form-label"
  }, "Vencimiento Tarjeta"), /*#__PURE__*/React.createElement(CardDate, {
    value: poliza.payment_information.card_expiration,
    onChange: function onChange(date) {
      return _onChange && _onChange(_objectSpread(_objectSpread({}, poliza.payment_information), {}, {
        card_expiration: date
      }));
    }
  }))));
};

export default CreditCardInfo;